import * as React from "react";
import Btn from "@warda/library-ui/core/Btn";
import { isEmpty } from "lodash-es";
import { ACT_VPORT } from "../reducer";
import { useContextDispatchViewport } from "../SharePage";
const BtnNavigateBack = ({ className, style, folderPath, }) => {
    const dispatchViewport = useContextDispatchViewport();
    const cbOnNavigateBack = React.useCallback(() => {
        dispatchViewport({ type: ACT_VPORT.NAVIGATION });
    }, [dispatchViewport]);
    if (isEmpty(folderPath))
        return null;
    return (React.createElement(Btn, { className: className, style: style, icon: "arrow_back", tooltip: "Back", onClick: cbOnNavigateBack }));
};
export default BtnNavigateBack;
